import { isEmpty, trim } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import youtube from "@/assets/images/webp/video-thumb.webp";

const ImageVideoCarosel = (props) => {

  const [mediaItems, setMediaItems] = useState([]);
  const caroselRef = useRef(null);

  const handleSlideLeft = () => {
    caroselRef.current.prev();
  };

  const handleSlideRight = () => {
    caroselRef.current.next();
  };

  useEffect(() => {
    if (!isEmpty(props.mediaItems)) {
      setMediaItems(props.mediaItems);
    }
  }, [props]);

  return (<>
    <Carousel data-bs-theme="dark" indicators={false} controls={false} ref={caroselRef} interval={null}>

      {
        mediaItems && mediaItems.map((val, idx) => {
          console.log("value ==== ", val);
          // console.log("crosl item ===========", val.src);
          let x = trim(val.src);
          // console.log("x ===========", val.src);

          if (val.type === "Video") {
            let s = val.src;
            let x = s.includes("youtube.com");
            // console.log("x >>>>>>>>>. ", x);
            if (x) {
              let x1 = s.replace("watch?v=", "embed/");
              // console.log("x1 ========= ", x1);
              s = x1;

              return (<Carousel.Item key={`item_${idx}`}><div key={`inner_div_item_${idx}`}>
                <iframe src={val.src} title="W3Schools Free Online Web Tutorials" style={{
                  display: 'block',
                  height: '500px',
                  margin: 'auto',
                  width: '100%',
                  overflow: "hidden"
                }}
                  key={`inner_i_div_item_${idx}`}
                ></iframe>
              </div></Carousel.Item>)
            } else {
              return (<Carousel.Item key={`item_${idx}`}><div key={`inner_div_item_${idx}`}>
                <Link to={val.src} href={val.src} target="_blank">
                  <img src={youtube} title="W3Schools Free Online Web Tutorials" style={{
                    display: 'block',
                    height: '500px',
                    margin: 'auto',
                    width: '100%',
                    overflow: "hidden"
                  }}
                    key={`inner_i_div_item_${idx}`}
                  />
                </Link>

              </div></Carousel.Item>)
            }

          } else {
            return (
              <Carousel.Item key={`item_${idx}`}><div key={`inner_div_item_${idx}`}>
                <img
                  src={val.src}
                  alt=""
                  style={{
                    display: 'block',
                    margin: 'auto',
                    width: '100%',
                    overflow: "hidden"
                  }}
                  key={`inner_i_div_item_${idx}`}
                />
              </div></Carousel.Item>)
          }
        })
      }

    </Carousel>
    <div className='arrow-wrapper d-flex justify-content-center my-3'>
      <button type="button" className="btn prev-custom-button mx-2" onClick={handleSlideLeft}>
        <i className="fa-solid fa-chevron-left"></i>
      </button>
      <button type="button" className="btn next-custom-button" onClick={handleSlideRight}>
        <i className="fa-solid fa-chevron-right"></i>
      </button>
    </div>
  </>)
}

export default ImageVideoCarosel;